import React, { useState } from 'react';
import {
  HiUser,
  HiCash,
  HiClipboardCheck,
  HiRefresh,
  HiClipboardCopy,
  HiBadgeCheck,
  HiCloudUpload,
} from 'react-icons/hi';
import { Stepper, Step } from '@material-tailwind/react';
import { useTranslation } from 'react-i18next';

const SetStatusBar = ({ status }) => {
  const [listStatus] = useState([
    'Initial',
    'Submitted',
    'Paym. Confirmed',
    'Preparing',
    'Draft sent',
    'Signed',
    'Filled',
  ]);
  const { t } = useTranslation();

  return (
    <Stepper
      className="flex list-none mb-4"
      activeStep={listStatus.indexOf(status)}
    >
      {listStatus.map((e, index) => {
        return (
          <Step key={e}>
            {e === 'Initial' ? <HiUser /> : null}
            {e === 'Submitted' ? <HiCloudUpload /> : null}
            {e === 'Paym. Confirmed' ? <HiCash /> : null}
            {e === 'Preparing' ? <HiRefresh /> : null}
            {e === 'Draft sent' ? <HiClipboardCopy /> : null}
            {e === 'Signed' ? <HiClipboardCheck /> : null}
            {e === 'Filled' ? <HiBadgeCheck /> : null}
            <div
              className={`absolute -bottom-[1.5rem] w-max text-center ${
                status === e ? 'text-blue-gray-900' : 'text-gray-500'
              }`}
            >
              {t(e)}
            </div>
          </Step>
        );
      })}
    </Stepper>
  );
};
export default SetStatusBar;
